import ProxyUrls from '@/constants/ProxyUrls';
import Vue from 'vue';
import * as _ from 'lodash';

export default {
  namespaced: true,
  state: {
    featureFlags: {}
  },
  actions: {
    async fetchInstanceFeatFlags({commit, state}) {
      try {
        // Setup URL and make API call
        const {
          data,
        } = await Vue.prototype.$axios({
          url: ProxyUrls.getInstanceFeatFlags,
          withCredentials: true,
          method: 'get',
        });

        if (data && data.httpStatus === 200) {
          commit('setFeatFlags', data.responseData);
          console.log(data.responseData);
        } else throw new Error('No Content');
      }
      catch (err) {
        console.log(err); // Don't propagate the error cuz this method is called before app is mounted
      }
    },
  },
  mutations: {
    setFeatFlags(state, payload) {
      state.featureFlags = _.cloneDeep(payload);
    }
  },
  getters: {
    isEnabled: (state) => (flag) => {
      if (!flag) return false;

      // Check the flag status by checking whats in the state
      try{
        if(_.has(state.featureFlags, flag)) {
          return state.featureFlags[flag];
        }
        return false;
      }
      catch(error) {
        console.log(error);
        return false;
      }
    }
  }
};
